// extracted by mini-css-extract-plugin
module.exports = {"container":"allocatedMembers_container__1ILu2"};